import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { CustomButton } from "../StyledElements";

const handleFunction = async (func) => {
  const result = await (async () => {
    const res = func(); // Call the function
    return res instanceof Promise ? res : Promise.resolve(res); // Check if it's a promise
  })();
  return result;
};

export function ModalFooterWrapper({ elements = [] }) {
  // Check if the device is in landscape orientation
  const isLandscape = useMediaQuery("(orientation: landscape)");

  // Logic to determine Stack direction

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      sx={{
        justifyContent: {
          xs:
            isLandscape || elements.filter((x) => x.length > 2)
              ? "flex-end"
              : "flex-start",
          md: "flex-end",
        },
        alignItems: "center",
      }}
    >
      {elements.map(
        (element, idx) =>
          element && (
            <Grid
              key={`modal-footer-elem-container-${idx}`}
              item
              xs={isLandscape ? "auto" : 6}
              md="auto"
            >
              {element}
            </Grid>
          ),
      )}
    </Grid>
  );
}

ModalFooterWrapper.propTypes = {
  elements: PropTypes.array,
};

export default function ModalFooter({ buttons = [] }) {
  const [inProgressIdx, setInProgressIdx] = useState(null);

  return (
    <ModalFooterWrapper
      elements={buttons.map(
        (btn, idx) =>
          btn && (
            <CustomButton
              key={`modal-footer-btn-container-${idx}`}
              style={{ width: "100%" }}
              onClick={async () => {
                setInProgressIdx(idx);
                await handleFunction(btn.onClick);
                setInProgressIdx(null);
              }}
              disabled={btn.disabled || inProgressIdx !== null}
              {...(btn.props || {})}
            >
              {inProgressIdx === idx ? (
                <CircularProgress color="primary" size="24px" />
              ) : (
                btn.label
              )}
            </CustomButton>
          ),
      )}
    />
  );
}

ModalFooter.propTypes = {
  buttons: PropTypes.array,
};
